import { Component, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import * as $ from 'jquery';

@Component({
  selector: 'app-panadol',
  templateUrl: './panadol.component.html',
  styleUrls: ['./panadol.component.css']
})
export class PanadolComponent implements OnInit {
  active: Number = 0;

  constructor(private modalService: NgbModal) {
    setTimeout(() => { 
      this.calculateTableWidth();
      $(".table-container").css('visibility', 'visible');
     }, 500);
  }

  ngOnInit(): void {
    $(".row-1").on("click", (event:any) => {
      var columnIndex = $(event.target).parent().attr("id")?.replace("parent-div-","");
      var val = $("#parent-div-" + columnIndex).css('transform');
      $(".column").css('transform', 'none').css('filter','unset');
      $(".left-header").css('transform', 'none').css('filter','unset');
      if(val == "none") {
        $("#parent-div-" + columnIndex)
        .css('filter', 'drop-shadow(rgb(68, 68, 68) 0px 20px 10px)').css('transform', 'scale(1.137) translateY(30px)');
        var height = parseInt($("#parent-div-" + columnIndex).css('height'));
        height = height*1.15;
        $(".right-side").css('height', height + 'px');
        $(".left-header").css('transform', 'scale(1.137) translateY(30px)').css('filter','drop-shadow(rgb(68, 68, 68) 0px 20px 10px)');
      }
      else {
        $("#parent-div-" + columnIndex).css('filter','unset').css('transform', 'none');
        var height = parseInt($("#parent-div-" + columnIndex).css('height'));
        height = height-1.15;
        $(".right-side").css('height', height + 'px');
      }
    }
    );

  }

  open(content: any) {
    this.modalService.open(content, { size: 'lg', ariaLabelledBy: 'modal-basic-title' }).result.then((result) => {

    }, (reason) => {

    });
  }
  calculateTableWidth() {
    var rows = 6;
    for (var index = 0; index <= rows; index++) {
      var maxHeight = 0;
      $(".right-side .row-" + index).each((row: any, ele: any) => {
        var $this = $(ele);
        var tdHeight = $this.outerHeight();
        if (tdHeight == undefined)
          tdHeight = 0;
        if (maxHeight < tdHeight)
          maxHeight = tdHeight;
      });
      $(".row-" + index).css("height", (maxHeight + 5) + "px");
    }
  }
}
